import React from 'react';
import { BorderColor, Science, RocketLaunch } from '@mui/icons-material';
import StatusChip, { StatusChipVariant } from '@shared/components/StatusChip/StatusChip';

interface SyncOnChipProps {
    value: string;
    variant?: 'light' | 'outlined' | 'filled';
    showIcon?: boolean;
    size?: 'small' | 'medium';
}

const syncOnConfig = {
    draft: {
        label: 'Draft',
        status: 'secondary' as StatusChipVariant,
        icon: <BorderColor />,
    },
    staging: {
        label: 'Sandbox',
        status: 'primary' as StatusChipVariant,
        icon: <Science />,
    },
    prod: {
        label: 'Production',
        status: 'success' as StatusChipVariant,
        icon: <RocketLaunch />,
    },
    production: {
        label: 'Production',
        status: 'success' as StatusChipVariant,
        icon: <RocketLaunch />,
    },
};

export const SyncOnChip: React.FC<SyncOnChipProps> = ({
    value,
    variant = 'light',
    showIcon = true,
    size = 'medium',
}) => {
    const config = syncOnConfig[value as keyof typeof syncOnConfig] || syncOnConfig.draft;

    return (
        <StatusChip
            customIcon={config.icon}
            label={config.label}
            status={config.status}
            showIcon={showIcon}
            variant={variant}
            size={size}
        />
    );
};

export default SyncOnChip;
